import { create, type StoreApi, type UseBoundStore } from 'zustand';
import { persist } from 'zustand/middleware';

type Store = {
  close: () => void;
  isOpen: boolean;
  open: () => void;
  toggler: (state: boolean) => void;
};

type DropdownStore = UseBoundStore<StoreApi<Store>>;

const dropdownStores = new Map<string, DropdownStore>();

export const closeAllDropdowns = () => {
  dropdownStores.forEach((store) => store.getState().close());
};

export const createDropdownStore = (key: string) =>
  dropdownStores.get(key) ??
  (() => {
    const store = create<Store>()(
      persist(
        (set) => ({
          isOpen: false,
          fileLinks: [],

          open: () => {
            set({ isOpen: true });
          },

          close: () => {
            set({ isOpen: false });
          },

          toggler: (state) => {
            set({ isOpen: state });
          },
        }),
        {
          name: `dropdown-${key}`,
        },
      ),
    );

    dropdownStores.set(key, store);

    return store;
  })();
